export default __webpack_public_path__ + "static/media/prateleira_montantes_01.69c4007a.png";